import axios, { AxiosResponse } from 'axios';
import { apiClient } from '../apiClient';

export interface MachineType {
    _id: string;
    designation: string;
    price: number;
    priceType: number;
    crudStatus: number;
    usageCount?: {
        total: number;
        machines: number;
    };
    displayOrder?: number;
    updatedAt?: string;
    createdAt?: string;
}

export interface MachineTypesResponse {
    message: string;
    data: MachineType[];
}

export interface MachineTypeResponse {
    message: string;
    data: MachineType;
}

export interface GetMachinesTypesQueries {
    active?: boolean;
    withUsage?: boolean;
}

export interface CreateMachineTypeBody {
    designation: string;
    price: number;
    priceType: number;
    crudStatus?: number;
    displayOrder?: number | null;
}

export interface UpdateMachineTypeBody {
    designation?: string;
    price?: number;
    priceType?: number;
    crudStatus?: number;
    displayOrder?: number | null;
}

export const getAllMachineTypes = async (queries?: GetMachinesTypesQueries): Promise<MachineTypesResponse> => {
    try {
        const response: AxiosResponse<MachineTypesResponse> = await apiClient.get('/machine-types', { params: queries });
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        }
        throw new Error('An unexpected error occurred while fetching machine types.');
    }
};

export const createMachineType = async (data: CreateMachineTypeBody): Promise<MachineTypeResponse> => {
    try {
        const response: AxiosResponse<MachineTypeResponse> = await apiClient.post('/machine-types', data);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        }
        throw new Error('An unexpected error occurred while creating machine type.');
    }
};

export const updateMachineType = async (id: string, data: UpdateMachineTypeBody): Promise<MachineTypeResponse> => {
    try {
        const response: AxiosResponse<MachineTypeResponse> = await apiClient.patch(`/machine-types/${id}`, data);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        }
        throw new Error('An unexpected error occurred while updating machine type.');
    }
};
